module.exports = __webpack_public_path__ + "img/p3only.c0d185b4.png";